import type { Resolver } from 'cpool-schemas';
import { schemaGroupAssignment } from 'cpool-schemas';
import type { z } from 'zod';

type Arguments = {
    userId: string;
};

export const schemaUserResolver_GetGroupAssignment = schemaGroupAssignment.nullable();

export type SchemaUserResolver_GetGroupAssignment = z.infer<typeof schemaUserResolver_GetGroupAssignment>;

export type UserResolver_GetGroupAssignment = Resolver<Arguments, SchemaUserResolver_GetGroupAssignment>;
